module.exports = __webpack_public_path__ + "img/奧圖碼.5dc6979c.png";